import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import "./App.scss";

import Dashboard from "../Pages/private/Dashboard/Dashboard";
import UserProfile from "../Pages/private/UserProfile/UserProfileContainer";
import Login from "../Pages/public/Login/LoginContainer";
import Payments from "../Pages/public/Payments/PaymentsContainer";
import Register from "../Pages/public/Register/RegisterContainer";
import ResetPassword from "../Pages/public/ResetPassword/ResetPasswordContainer";
import { setHeaders } from "../redux/utils";

import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

import Toaster from "../App/Components/Toaster/Toaster";
import { addToast } from "../redux/ui/creators";

import { Amplify, Auth, Hub } from "aws-amplify";
import { connect } from "react-redux";
import getConfig, { isProductionEnvironment } from "../aws-config";
import PublicCredentials from "../Pages/public/PublicCredentials/PublicCredentials";
import { setUser, storeSession } from "../redux/auth/creators";
import { Alert } from "@material-ui/lab";

Amplify.configure(getConfig());

const mapStateToProps = function (state: any) {
	return {
		auth: state.auth,
	};
};
const App = (props: any) => {
	const [session, setSession] = useState(null);
	const [loadingSession, setloadingSession] = useState(true);

	const { setUser, storeSession } = props;

	useEffect(() => {
		console.log("cevaa");
		Hub.listen("auth", ({ payload: { event, data } }) => {
			console.log("hub listen");
			switch (event) {
				// const session = data.signInUserSession;
				// case "signIn" || "autoSignIn" || "tokenRefresh":
				// 	console.log("sign in normal");
				// 	console.log(data);
				// 	Auth.currentUserInfo().then((r) => {
				// 		setUser(r);
				// 		setloadingSession(false);
				// 		setSession(session);
				// 		storeSession(session);
				// 		setHeaders({
				// 			"Content-Type": "application/json",
				// 			Authorization: `Bearer ${session.accessToken.jwtToken}`,
				// 			IdToken: session.idToken.jwtToken,
				// 		});
				// 	});
				// 	break;
				case "cognitoHostedUI":
					console.log("sign in hosted ui");
					console.log(data);
					break;
				case "signOut":
					console.log("sign in");
					// setUser(null);
					break;
				case "signIn_failure":
					console.log("fail");
					break;
				case "cognitoHostedUI_failure":
					console.log("Sign in failure", data);
					break;
			}
		});
		console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
		Auth.currentAuthenticatedUser().then((r: any) => {
			console.log("currentAuthenticatedUser", r);
		});
		Auth.currentSession()
			.then((r: any) => {
				console.log("currentSession", r);
				setSession(r);
				storeSession(r);
				setHeaders({
					"Content-Type": "application/json",
					Authorization: `Bearer ${r.accessToken.jwtToken}`,
					IdToken: r.idToken.jwtToken,
				});

				Auth.currentUserInfo().then((r) => {
					setUser(r);
					setloadingSession(false);
				});
			})
			.catch((e) => {
				setSession(null);
				setloadingSession(false);
				localStorage.removeItem("jwt");
			});
	}, [setUser, storeSession, props.auth.didLogin]);
	function getUser() {
		return Auth.currentAuthenticatedUser()
			.then((userData) => userData)
			.catch(() => console.log("Not signed in"));
	}
	return (
		<div className="App">
			{!isProductionEnvironment ? (
				<Alert variant="filled" severity="warning">
					UAT Environment.
				</Alert>
			) : null}
			{!loadingSession && (
				<Switch>
					<PrivateRoute component={Dashboard} path="/dashboard" exact />
					<PrivateRoute component={Dashboard} path="/" exact />
					<PrivateRoute component={UserProfile} path="/my-account" exact />
					<PublicRoute restricted={false} component={Login} path="/login" exact />
					<PublicRoute restricted={false} component={Register} path="/register" exact />
					<PublicRoute restricted={false} component={ResetPassword} path="/reset-password" exact />
					<PublicRoute restricted={false} component={Payments} path="/payments" exact />
					<Route path="/credentials/:id" exact>
						<PublicCredentials />
					</Route>
				</Switch>
			)}
			<Toaster />
		</div>
	);
};

export default connect(mapStateToProps, (dispatch: any) => {
	return {
		storeSession: dispatch(storeSession),
		setUser: dispatch(setUser),
		addToast: dispatch(addToast),
	};
})(App);
